/* =========================================================
   MAIN FILTER PAGE
   ========================================================= */

window.STOREFRONT_API_VERSION =
  window.STOREFRONT_API_VERSION || '2026-07';

/* =========================================================
   MODALS
   ========================================================= */

function openModal(id) {
  var html = document.documentElement;
  var modal = document.querySelector('#' + id + '.modal__outside');

  if (!modal) {
    console.warn('Modal not found:', id);
    return;
  }

  html.classList.add('lock-scroll');
  modal.classList.add('is-open');
}

function closeModal() {
  var html = document.documentElement;
  var modal = document.querySelector('.modal__outside.is-open');

  if (modal) {
    modal.classList.remove('is-open');
  }

  html.classList.remove('lock-scroll');
}

function initializeModals() {
  var modals = document.querySelectorAll('.modal__outside');

  modals.forEach(function (modal) {
    modal.addEventListener('click', function (event) {
      if (
        event.target.closest('.modal__close') ||
        event.target === modal
      ) {
        closeModal();
      }
    });
  });
}


/* =========================================================
   GLOBAL PRODUCT VARIABLES
   ========================================================= */

var resultHandle = '';
var currentString = '';

/* =========================================================
   INITIALIZATION
   ========================================================= */

function initializeFilterPage() {
  console.log('Initializing filter page');

  initializeModals();
  initializeMervCards();
  initializeDimensionInputs();
  initializeAddToCart();

  loadSavedDimensions();

  /*
   * Wait until saved values have been applied before
   * performing the first validation/search.
   */
  setTimeout(function () {
    checkStepCompletion();
  }, 100);
}


/*
 * Because this file is loaded with defer, DOMContentLoaded
 * will normally not have fired yet. This also protects against
 * the script being loaded dynamically.
 */
if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeFilterPage
  );
} else {
  initializeFilterPage();
}


/* =========================================================
   MERV CARDS
   ========================================================= */

function initializeMervCards() {
  var mervCards = document.querySelectorAll('.merv-card');

  if (!mervCards.length) {
    console.warn('No .merv-card elements found');
    return;
  }

  mervCards.forEach(function (card) {
    card.addEventListener('click', function () {
      /*
       * Remove selected state from every MERV card.
       */
      mervCards.forEach(function (item) {
        item.classList.remove('selected');
        item.classList.add('unselected');

        var radio = item.querySelector(
          'input[type="radio"]'
        );

        if (radio) {
          radio.checked = false;
        }
      });

      /*
       * Select clicked card.
       */
      card.classList.remove('unselected');
      card.classList.add('selected');

      var radioButton = card.querySelector(
        'input[type="radio"]'
      );

      if (radioButton) {
        radioButton.checked = true;
      }

      console.log(
        'MERV selected:',
        radioButton ? radioButton.value : 'none'
      );

      checkStepCompletion();
      handleDimensionChange();
    });
  });
}


/* =========================================================
   DIMENSION INPUTS
   ========================================================= */

function initializeDimensionInputs() {
  var dimensionInputs = document.querySelectorAll(
    '#length-main, ' +
    '#length-fraction, ' +
    '#width-main, ' +
    '#width-fraction, ' +
    '#depth-main'
  );

  dimensionInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      saveDimensionsToStorage();
      checkStepCompletion();
      handleDimensionChange();
    });
  });
}


/* =========================================================
   QUANTITY
   ========================================================= */

function decreaseQuantity() {
  var quantityValue =
    document.getElementById('quantity-value');

  if (!quantityValue) {
    return;
  }

  var currentValue =
    parseInt(quantityValue.textContent, 10) || 1;

  if (currentValue > 1) {
    var newValue = currentValue - 1;

    quantityValue.textContent = newValue;

    updatePricing(newValue);
  }
}

function increaseQuantity() {
  var quantityValue =
    document.getElementById('quantity-value');

  if (!quantityValue) {
    return;
  }

  var currentValue =
    parseInt(quantityValue.textContent, 10) || 1;

  var newValue = currentValue + 1;

  quantityValue.textContent = newValue;

  updatePricing(newValue);
}


/* =========================================================
   PRICING
   ========================================================= */

function getActualProductPrice() {
  var addToCartBtn =
    document.querySelector('.add-to-cart-btn');

  if (
    addToCartBtn &&
    addToCartBtn.dataset.basePrice
  ) {
    var price =
      parseFloat(addToCartBtn.dataset.basePrice);

    if (!isNaN(price)) {
      return price;
    }
  }

  return 35.49;
}

function updatePricing(quantity) {
  var basePricePerCase =
    getActualProductPrice();

  var filtersPerCase = 6;

  var totalPrice =
    basePricePerCase * quantity;

  var costPerFilter =
    totalPrice /
    (quantity * filtersPerCase);

  var costElement =
    document.querySelector('.cost-info');

  if (costElement) {
    costElement.textContent =
      'Cost per filter: $' +
      costPerFilter.toFixed(2);
  }

  var addToCartBtn =
    document.querySelector('.add-to-cart-btn');

  if (addToCartBtn) {
    addToCartBtn.textContent =
      'Add to cart - $' +
      totalPrice.toFixed(2);
  }
}

function updatePricingFromProduct() {
  var quantityElement =
    document.getElementById('quantity-value');

  if (!quantityElement) {
    return;
  }

  var quantity =
    parseInt(quantityElement.textContent, 10) || 1;

  updatePricing(quantity);
}


/* =========================================================
   DIMENSION VALIDATION
   ========================================================= */

function validateDimensions() {
  var lengthMain =
    document.getElementById('length-main');

  var widthMain =
    document.getElementById('width-main');

  var depthMain =
    document.getElementById('depth-main');

  if (
    !lengthMain ||
    !widthMain ||
    !depthMain
  ) {
    return false;
  }

  return (
    lengthMain.value !== '' &&
    widthMain.value !== '' &&
    depthMain.value !== ''
  );
}


/* =========================================================
   STORE FRONT API - TAG FIRST SEARCH
   ========================================================= */

async function searchTagFirst(queryTag,querySku) {
  console.log(
    'Tag-first search:',
    queryTag,querySku
  );

  var addToCartBtn =
    document.querySelector('.add-to-cart-btn');

  if (addToCartBtn) {
    addToCartBtn.textContent = 'Searching...';
    addToCartBtn.disabled = true;
  }

  var storefrontToken = '0f40cc16cf5a207301322723074ff31d';

  var storefrontApiVersion =
    window.STOREFRONT_API_VERSION ||
    '2026-07';

  /*
   * If Storefront API token isn't configured,
   * fall back to predictive search.
   */
  if (!storefrontToken) {
    console.warn(
      'STOREFRONT_API_TOKEN is not configured.'
    );

    predictQuery(queryTag, querySku);
    return;
  }

  var storefrontQuery = `
    query SearchProductsByTag($query: String!) {
      products(first: 250, query: $query) {
        nodes {
          handle
          title
          tags
          variants(first: 250) {
            nodes {
              id
              sku
              availableForSale
            }
          }
        }
      }
    }
  `;

  try {
    var response = await fetch(
      '/api/' +
        storefrontApiVersion +
        '/graphql.json',
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token':
            storefrontToken
        },

        body: JSON.stringify({
          query: storefrontQuery,

          variables: {
            query:
              'tag:"' +
              String(queryTag)
                .replace(/"/g, '\\"') +
              '"'
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        'Storefront API request failed: ' +
        response.status
      );
    }

    var data =
      await response.json();

    if (
      data.errors &&
      data.errors.length
    ) {
      console.error(
        'Storefront API errors:',
        data.errors
      );

      throw new Error(
        'Storefront API returned errors'
      );
    }

    var products =
      data &&
      data.data &&
      data.data.products &&
      Array.isArray(
        data.data.products.nodes
      )
        ? data.data.products.nodes
        : [];

    console.log(
      'Storefront tag results:',
      products
    );

    /*
     * IMPORTANT:
     *
     * Shopify search only gives candidate products.
     * We still check the actual tags ourselves.
     *
     * This means:
     *
     * ActualSize:[8][10.000]x[10.000]x[1.000]
     *
     * must exactly equal a product tag.
     */

    var normalizedQueryTag =
      String(queryTag).trim();

    var tagMatch = null;

    for (
      var i = 0;
      i < products.length;
      i++
    ) {
      var product = products[i];

      if (
        !product ||
        !Array.isArray(product.tags)
      ) {
        continue;
      }

      var exactTagMatch =
        product.tags.some(function (tag) {
          return (
            String(tag).trim() ===
            normalizedQueryTag
          );
        });

      var standardTagMatch =
        product.tags.some(function (tag) {
          return String(tag).trim() === 'Standard';
        });

      // Accept the product only when BOTH tags match exactly.
      if (exactTagMatch && standardTagMatch) {
        tagMatch = product;
        break;
      }
    }

    /*
     * =====================================================
     * EXACT TAG MATCH
     * =====================================================
     */

    if (tagMatch) {
      console.log(
        'EXACT TAG MATCH FOUND:',
        tagMatch
      );

      resultHandle =
        tagMatch.handle;

      showStandardSizeResult(
        tagMatch.title,
        tagMatch.handle
      );

      return;
    }

    /*
     * =====================================================
     * NO TAG MATCH
     * =====================================================
     *
     * Fall back to the original predictive search,
     * which searches SKU/tag candidates.
     */

    console.log(
      'No exact tag match found.'
    );

    console.log(
      'Falling back to predictive search.'
    );

    predictQuery(
      queryTag,
      querySku
    );

  } catch (error) {
    console.error(
      'Tag search failed:',
      error
    );

    /*
     * Preserve fallback behavior.
     */
    predictQuery(
      queryTag,
      querySku
    );
  }
}


/* =========================================================
   STANDARD SIZE RESULT
   ========================================================= */

function showStandardSizeResult(
  productTitle,
  productHandle
) {
  var targetDiv =
    document.querySelector('.resultanc');

  var step3 =
    document.querySelector('.step-3-section');

  var step4 =
    document.querySelector('.step-4-section');

  var addToCartSection =
    document.querySelector('.add-to-cart-section');

  var step2Divider =
    document.querySelector('.step-2-divider');

  var step3Divider =
    document.querySelector('.step-3-divider');

  var step4Divider =
    document.querySelector('.step-4-divider');

  /*
   * Hide quantity and ReCharge because this
   * is a standard-size product result.
   */
  if (step3) {
    step3.style.display = 'none';
    step3.classList.remove('step-visible');
  }

  if (step4) {
    step4.style.display = 'none';
    step4.classList.remove('step-visible');
  }

  if (addToCartSection) {
    addToCartSection.style.display = 'none';
    addToCartSection.classList.remove(
      'step-visible'
    );
  }

  if (step2Divider) {
    step2Divider.style.display = 'none';
  }

  if (step3Divider) {
    step3Divider.style.display = 'none';
  }

  if (step4Divider) {
    step4Divider.style.display = 'none';
  }

  if (targetDiv) {
    targetDiv.innerHTML =
      '<h1>We found a standard size ' +
      escapeHtml(productTitle || '') +
      '</h1>' +
      '<br>' +
      '<a ' +
      'style="' +
      'background:#09196c;' +
      'border:none;' +
      'border-radius:33px;' +
      'height:45px;' +
      'width:35%;' +
      'font-family:Poppins,sans-serif;' +
      'font-weight:600;' +
      'font-size:16px;' +
      'color:#fff;' +
      'letter-spacing:.32px;' +
      'display:block;' +
      'text-align:center;' +
      'padding-top:10px;' +
      '"' +
      ' href="/products/' +
      encodeURIComponent(productHandle) +
      '">' +
      'View Product' +
      '</a>';
  }

  console.log(
    'Standard product displayed:',
    productHandle
  );
}


/* =========================================================
   ESCAPE HTML
   ========================================================= */

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}


/* =========================================================
   PREDICTIVE SEARCH FALLBACK
   ========================================================= */

function predictQuery(
  queryTag,
  querySku
) {
  console.log(
    'Predictive search:',
    queryTag,
    querySku
  );

  var addToCartBtn =
    document.querySelector('.add-to-cart-btn');

  if (addToCartBtn) {
    addToCartBtn.textContent =
      'Searching...';

    addToCartBtn.disabled = true;
  }

  /*
   * Keep SKU and tag as separate search terms.
   *
   * IMPORTANT:
   * The result is still verified against the
   * actual tag/SKU below.
   */

  currentString =
    querySku +
    ' OR ' +
    queryTag;

  console.log(
    'Search string:',
    currentString
  );

  var searchObj = {
    q: currentString,

    'resources[type]':
      'product',

    'resources[limit]':
      30,

    'resources[options][unavailable_products]':
      'last',

    'resources[options][fields]':
      'tag,variants.sku'
  };

  var params =
    paramUrl(searchObj);

  fetch(
    '/search/suggest.json?' +
    params
  )
    .then(function (response) {
      return response.json();
    })

    .then(function (suggestions) {
      console.log(
        'Predictive search results:',
        suggestions
      );

      var resultTypes =
        suggestions &&
        suggestions.resources &&
        suggestions.resources.results
          ? suggestions.resources.results
          : {};

      var allResults = [];

      Object.keys(resultTypes).forEach(
        function (type) {
          var results =
            resultTypes[type];

          if (
            Array.isArray(results)
          ) {
            allResults =
              allResults.concat(results);
          }
        }
      );

      console.log(
        'All predictive results:',
        allResults
      );

      if (!allResults.length) {
        showNoProductsFound();
        return;
      }

      /*
       * ===================================================
       * FIRST PRIORITY:
       * EXACT TAG MATCH
       * ===================================================
       */

      var exactTagProduct = null;

      for (
        var i = 0;
        i < allResults.length;
        i++
      ) {
        var result =
          allResults[i];

        if (
          !result ||
          !Array.isArray(result.tags)
        ) {
          continue;
        }

        var tagMatch =
          result.tags.some(
            function (tag) {
              return (
                String(tag).trim() ===
                String(queryTag).trim()
              );
            }
          );

        if (tagMatch) {
          exactTagProduct =
            result;

          break;
        }
      }

      if (exactTagProduct) {
        console.log(
          'Predictive exact tag match:',
          exactTagProduct
        );

        resultHandle =
          exactTagProduct.handle;

        /*
         * If the tag result has variants,
         * continue with normal product flow.
         */

        if (
          exactTagProduct.variants &&
          exactTagProduct.variants.length
        ) {
          var exactVariant =
            exactTagProduct.variants[0];

          var exactVariantId =
            exactVariant.id;

          clearStandardResult();

          showPurchaseSections();

          fetchProductData(
            resultHandle,
            exactVariantId
          );

          return;
        }

        /*
         * No variants means standard-size
         * product page.
         */

        showStandardSizeResult(
          exactTagProduct.title,
          exactTagProduct.handle
        );

        return;
      }

      /*
       * ===================================================
       * SECOND PRIORITY:
       * SKU MATCH
       * ===================================================
       */

      var skuProduct = null;
      var skuVariantId = null;

      for (
        var s = 0;
        s < allResults.length;
        s++
      ) {
        var skuResult =
          allResults[s];

        if (
          !skuResult ||
          !Array.isArray(
            skuResult.variants
          )
        ) {
          continue;
        }

        for (
          var v = 0;
          v < skuResult.variants.length;
          v++
        ) {
          var variant =
            skuResult.variants[v];

          if (
            variant &&
            variant.sku &&
            String(
              variant.sku
            ).trim() ===
            String(
              querySku
            ).trim()
          ) {
            skuProduct =
              skuResult;

            skuVariantId =
              variant.id;

            break;
          }
        }

        if (skuProduct) {
          break;
        }
      }

      /*
       * If no exact SKU match was found,
       * use the first result that has variants.
       */

      if (!skuProduct) {
        for (
          var r = 0;
          r < allResults.length;
          r++
        ) {
          if (
            allResults[r] &&
            allResults[r].variants &&
            allResults[r].variants.length
          ) {
            skuProduct =
              allResults[r];

            skuVariantId =
              allResults[r]
                .variants[0]
                .id;

            break;
          }
        }
      }

      /*
       * ===================================================
       * PRODUCT FOUND
       * ===================================================
       */

      if (skuProduct) {
        resultHandle =
          skuProduct.handle;

        console.log(
          'Selected predictive result:',
          skuProduct
        );

        clearStandardResult();

        showPurchaseSections();

        fetchProductData(
          resultHandle,
          skuVariantId
        );

        return;
      }

      /*
       * ===================================================
       * NO PRODUCT
       * ===================================================
       */

      showNoProductsFound();
    })

    .catch(function (error) {
      console.error(
        'Predictive search error:',
        error
      );

      if (addToCartBtn) {
        addToCartBtn.textContent =
          'Search failed';

        addToCartBtn.disabled =
          true;
      }
    });
}


/* =========================================================
   SEARCH UI HELPERS
   ========================================================= */

function clearStandardResult() {
  var targetDiv =
    document.querySelector('.resultanc');

  if (targetDiv) {
    targetDiv.innerHTML = '';
  }
}

function showPurchaseSections() {
  var step3 =
    document.querySelector('.step-3-section');

  var addToCartSection =
    document.querySelector(
      '.add-to-cart-section'
    );

  var step3Divider =
    document.querySelector(
      '.step-3-divider'
    );

  if (step3) {
    step3.style.display = 'block';
    step3.classList.add('step-visible');
  }

  if (addToCartSection) {
    addToCartSection.style.display =
      'flex';

    addToCartSection.classList.add(
      'step-visible'
    );
  }

  if (step3Divider) {
    step3Divider.style.display =
      'block';
  }
}

function showNoProductsFound() {
  var addToCartBtn =
    document.querySelector(
      '.add-to-cart-btn'
    );

  if (addToCartBtn) {
    addToCartBtn.textContent =
      'No products found';

    addToCartBtn.disabled = true;
  }

  var targetDiv =
    document.querySelector('.resultanc');

  if (targetDiv) {
    targetDiv.innerHTML =
      '<p>No matching filter was found. Please check your dimensions.</p>';
  }

  hideRecharge();
}


/* =========================================================
   PRODUCT DATA
   ========================================================= */

function fetchProductData(
  productHandle,
  searchVariantId
) {
  var addToCartBtn =
    document.querySelector(
      '.add-to-cart-btn'
    );

  if (!addToCartBtn) {
    return;
  }

  console.log(
    'Fetching product data:',
    productHandle
  );

  addToCartBtn.textContent =
    'Loading product...';

  var url =
    '/products/' +
    encodeURIComponent(
      productHandle
    ) +
    '.js';

  fetch(url)
    .then(function (response) {
      if (!response.ok) {
        throw new Error(
          'Product request failed: ' +
          response.status
        );
      }

      return response.json();
    })

    .then(function (product) {
      console.log(
        'Product data:',
        product
      );

      if (
        !product ||
        !Array.isArray(
          product.variants
        ) ||
        !product.variants.length
      ) {
        throw new Error(
          'Product has no variants'
        );
      }

      var actualVariant = null;

      /*
       * First try the exact variant ID
       * returned by predictive search.
       */

      if (searchVariantId) {
        actualVariant =
          product.variants.find(
            function (variant) {
              return (
                String(variant.id) ===
                String(searchVariantId)
              );
            }
          );
      }

      /*
       * If the exact variant isn't found,
       * use the first variant.
       */

      if (!actualVariant) {
        actualVariant =
          product.variants.find(
            function (variant) {
              return variant.available;
            }
          ) ||
          product.variants[0];
      }

      if (!actualVariant) {
        throw new Error(
          'No usable variant found'
        );
      }

      var actualVariantId =
        actualVariant.id;

      console.log(
        'Selected variant:',
        actualVariant
      );

      /*
       * Product price is returned in cents.
       */

      var variantPrice =
        parseFloat(
          actualVariant.price
        ) / 100;

      if (isNaN(variantPrice)) {
        throw new Error(
          'Invalid product price'
        );
      }

      var quantityElement =
        document.getElementById(
          'quantity-value'
        );

      var quantity =
        quantityElement
          ? parseInt(
              quantityElement.textContent,
              10
            ) || 1
          : 1;

      var totalPrice =
        variantPrice *
        quantity;

      var costPerFilter =
        variantPrice / 6;

      /*
       * Update Add to Cart button.
       */

      addToCartBtn.textContent =
        'Add to cart - $' +
        totalPrice.toFixed(2);

      addToCartBtn.disabled =
        false;

      /*
       * Update cost per filter.
       */

      var costElement =
        document.querySelector(
          '.cost-info'
        );

      if (costElement) {
        costElement.textContent =
          'Cost per filter: $' +
          costPerFilter.toFixed(2);
      }

      /*
       * Save product information on
       * the actual HTML button.
       */

      addToCartBtn.dataset.productHandle =
        productHandle;

      addToCartBtn.dataset.variantId =
        actualVariantId;

      addToCartBtn.dataset.basePrice =
        variantPrice;

      addToCartBtn.dataset.productId =
        product.id;

      /*
       * Load ReCharge.
       */

      if (product.id) {
        fetchProductHTMLForReCharge(
          productHandle,
          actualVariantId,
          product.id,
          actualVariant.price
        );
      }
    })

    .catch(function (error) {
      console.error(
        'Product fetch error:',
        error
      );

      addToCartBtn.textContent =
        'Product load failed';

      addToCartBtn.disabled =
        true;
    });
}


/* =========================================================
   RECHARGE
   ========================================================= */

function fetchProductHTMLForReCharge(
  productHandle,
  variantId,
  productId,
  productPrice
) {
  var url =
    '/products/' +
    encodeURIComponent(
      productHandle
    ) +
    '?view=custom-filter';

  if (variantId) {
    url +=
      '&variant=' +
      encodeURIComponent(
        variantId
      );
  }

  console.log(
    'Fetching product HTML for ReCharge:',
    url
  );

  fetch(url)
    .then(function (response) {
      if (!response.ok) {
        throw new Error(
          'Product HTML request failed: ' +
          response.status
        );
      }

      return response.text();
    })

    .then(function (html) {
      var parser =
        new DOMParser();

      var doc =
        parser.parseFromString(
          html,
          'text/html'
        );

      var productForm =
        doc.querySelector(
          'form[action="/cart/add"]'
        );

      if (!productForm) {
        console.warn(
          'Product form not found for ReCharge'
        );

        return;
      }

      /*
       * EXACT HTML CLASS FROM PROVIDED HTML:
       *
       * .recharge-widget-container
       */

      var rechargeContainer =
        document.querySelector(
          '.recharge-widget-container'
        );

      if (rechargeContainer) {
        rechargeContainer.style.display =
          'block';

        rechargeContainer.classList.add(
          'step-visible'
        );
      }

      /*
       * EXACT HTML ID FROM PROVIDED HTML:
       *
       * #recharge-widget-container
       */

      var widgetContainer =
        document.getElementById(
          'recharge-widget-container'
        );

      if (!widgetContainer) {
        console.warn(
          '#recharge-widget-container not found'
        );

        return;
      }

      /*
       * Build the hidden product form used
       * by ReCharge.
       */

      var tempContainer =
        document.createElement('div');

      tempContainer.className =
        'product-info__block step-three-section';

      tempContainer.setAttribute(
        'data-product-handle',
        productHandle
      );

      tempContainer.innerHTML =
        '<product-form>' +
        '<form ' +
        'action="/cart/add" ' +
        'method="post" ' +
        'enctype="multipart/form-data" ' +
        'class="js-product-form js-product-form-main" ' +
        'id="product-form-recharge-' +
        productId +
        '">' +

        '<input ' +
        'type="hidden" ' +
        'name="id" ' +
        'value="' +
        variantId +
        '">' +

        '<div class="product-info__add-to-cart" style="display:none;">' +
        '<div class="product-info__add-button">' +
        '<button type="submit" class="btn btn--primary" name="add">' +
        'Add to cart' +
        '</button>' +
        '</div>' +
        '</div>' +

        '</form>' +
        '</product-form>' +

        '<div class="product__price" style="display:none;">' +
        '<span class="price" data-product-price>$' +
        (
          parseFloat(productPrice) / 100
        ).toFixed(2) +
        '</span>' +
        '</div>';

      widgetContainer.innerHTML = '';

      widgetContainer.appendChild(
        tempContainer
      );

      /*
       * Initialize ReCharge.
       */

      initializeRechargeWidget(
        productId,
        tempContainer
      );
    })

    .catch(function (error) {
      console.error(
        'Failed to fetch product HTML:',
        error
      );
    });
}


/* =========================================================
   RECHARGE INITIALIZATION
   ========================================================= */

function initializeRechargeWidget(
  productId,
  tempContainer
) {
  var attempts = 0;
  var maxAttempts = 20;

  function tryInitialize() {
    attempts++;

    if (
      window.ReChargeWidget &&
      typeof window.ReChargeWidget.createWidget ===
        'function'
    ) {
      try {
        var productForm =
          tempContainer.querySelector(
            'product-form'
          );

        if (
          productForm &&
          typeof productForm.init ===
            'function'
        ) {
          try {
            productForm.init();
          } catch (error) {
            console.warn(
              'Product form init warning:',
              error
            );
          }
        }

        window.ReChargeWidget.createWidget({
          productId: productId
        });

        console.log(
          'ReCharge widget initialized:',
          productId
        );

        monitorRechargeWidget();

      } catch (error) {
        console.error(
          'ReCharge widget error:',
          error
        );
      }

      return;
    }

    if (attempts < maxAttempts) {
      setTimeout(
        tryInitialize,
        500
      );
    } else {
      console.warn(
        'ReCharge widget did not become available.'
      );
    }
  }

  setTimeout(
    tryInitialize,
    300
  );
}


/* =========================================================
   RECHARGE VISIBILITY
   ========================================================= */

function monitorRechargeWidget() {
  var attempts = 0;
  var maxAttempts = 50;

  var interval =
    setInterval(function () {
      attempts++;

      var containers =
        document.querySelectorAll(
          '.rc-container, .rc-widget'
        );

      if (containers.length) {
        clearInterval(interval);

        containers.forEach(
          function (container) {
            forceRechargeVisibility(
              container
            );
          }
        );
      }

      if (
        attempts >= maxAttempts
      ) {
        clearInterval(interval);
      }
    }, 100);
}

function forceRechargeVisibility(
  container
) {
  if (!container) {
    return;
  }

  container.style.opacity = '1';
  container.style.visibility =
    'visible';
  container.style.display =
    'block';

  /*
   * Keep ReCharge from hiding itself.
   */

  if (
    typeof MutationObserver !==
    'undefined'
  ) {
    var observer =
      new MutationObserver(
        function () {
          if (
            container.style.display ===
              'none' ||
            container.style.visibility ===
              'hidden' ||
            container.style.opacity ===
              '0'
          ) {
            container.style.display =
              'block';

            container.style.visibility =
              'visible';

            container.style.opacity =
              '1';
          }
        }
      );

    observer.observe(
      container,
      {
        attributes: true,
        attributeFilter: [
          'style'
        ]
      }
    );
  }
}

function hideRecharge() {
  var rechargeContainer =
    document.querySelector(
      '.recharge-widget-container'
    );

  if (rechargeContainer) {
    rechargeContainer.style.display =
      'none';

    rechargeContainer.classList.remove(
      'step-visible'
    );
  }
}


/* =========================================================
   PARAM URL
   ========================================================= */

function paramUrl(obj) {
  return Object.keys(obj)
    .map(function (key) {
      return (
        key +
        '=' +
        encodeURIComponent(
          obj[key]
        )
      );
    })
    .join('&');
}


/* =========================================================
   FULL DIMENSIONS
   ========================================================= */

function fullDimensions() {
  var mervSelected =
    document.querySelector(
      'input[name="merv"]:checked'
    );

  var lengthMain =
    document.getElementById(
      'length-main'
    );

  var lengthFraction =
    document.getElementById(
      'length-fraction'
    );

  var widthMain =
    document.getElementById(
      'width-main'
    );

  var widthFraction =
    document.getElementById(
      'width-fraction'
    );

  var depth =
    document.getElementById(
      'depth-main'
    );

  if (
    !mervSelected ||
    !lengthMain ||
    !lengthFraction ||
    !widthMain ||
    !widthFraction ||
    !depth
  ) {
    return '';
  }

  var _length =
    parseFloat(lengthMain.value) +
    parseFloat(lengthFraction.value || 0);

  var _width =
    parseFloat(widthMain.value) +
    parseFloat(widthFraction.value || 0);

  var _depth =
    parseFloat(depth.value);

  var lengthDisplay =
    lengthMain.value +
    (
      parseFloat(
        lengthFraction.value
      ) !== 0
        ? ' ' +
          lengthFraction.options[
            lengthFraction.selectedIndex
          ].text
        : ''
    );

  var widthDisplay =
    widthMain.value +
    (
      parseFloat(
        widthFraction.value
      ) !== 0
        ? ' ' +
          widthFraction.options[
            widthFraction.selectedIndex
          ].text
        : ''
    );

  var firstDimension =
    _length < _width
      ? lengthDisplay
      : widthDisplay;

  var secondDimension =
    _width > _length
      ? widthDisplay
      : lengthDisplay;

  return (
    firstDimension +
    ' x ' +
    secondDimension +
    ' x ' +
    _depth +
    ' MERV' +
    mervSelected.value
  );
}


/* =========================================================
   RANGE FORMAT
   ========================================================= */

function rangeFormat(num) {
  var s =
    Math.floor(num) + '';

  while (s.length < 4) {
    s = '0' + s;
  }

  var subS =
    s.substring(0, 2);

  if (subS === '00') {
    subS = '01';
  }

  return subS + '99';
}


/* =========================================================
   DIMENSION CHANGE
   ========================================================= */

function handleDimensionChange() {
  var lengthMain =
    document.getElementById(
      'length-main'
    );

  var widthMain =
    document.getElementById(
      'width-main'
    );

  var depthMain =
    document.getElementById(
      'depth-main'
    );

  var lengthFraction =
    document.getElementById(
      'length-fraction'
    );

  var widthFraction =
    document.getElementById(
      'width-fraction'
    );

  var mervSelected =
    document.querySelector(
      'input[name="merv"]:checked'
    );

  if (
    !lengthMain ||
    !widthMain ||
    !depthMain ||
    !lengthFraction ||
    !widthFraction
  ) {
    return;
  }

  console.log(
    'Dimension change:',
    {
      length:
        lengthMain.value,
      width:
        widthMain.value,
      depth:
        depthMain.value,
      merv:
        mervSelected
          ? mervSelected.value
          : null
    }
  );

  var dimensionsFilled =
    lengthMain.value !== '' &&
    widthMain.value !== '' &&
    depthMain.value !== '';

  checkStepCompletion();

  if (
    !dimensionsFilled ||
    !mervSelected
  ) {
    return;
  }

  /*
   * Actual numeric dimensions.
   */

  var _length =
    parseFloat(lengthMain.value) +
    parseFloat(
      lengthFraction.value || 0
    );

  var _width =
    parseFloat(widthMain.value) +
    parseFloat(
      widthFraction.value || 0
    );

  var _depth =
    parseFloat(depthMain.value);

  /*
   * ActualSize tag.
   *
   * Example:
   *
   * ActualSize:[8][10.000]x[10.000]x[1.000]
   */

  var queryTag =
    'ActualSize:[' +
    mervSelected.value +
    '][' +
    _length.toFixed(3) +
    ']x[' +
    _width.toFixed(3) +
    ']x[' +
    _depth.toFixed(3) +
    ']';

  /*
   * SKU prefix comes from:
   *
   * data-sku="AF8"
   * data-sku="AF11"
   * data-sku="AF13"
   */

  var skuPrefix =
    mervSelected.dataset.sku ||
    'AF';

  /*
   * Determine CS/CD.
   */

  var isCD =
    (
      _length > 23.5 &&
      _width > 23.5
    ) ||
    _length > 25 ||
    _width > 25
      ? 'CD'
      : 'CS';

  /*
   * Generate range.
   */

  var range =
    rangeFormat(
      _length * _width
    );

  /*
   * Example:
   *
   * AF8CS.010199
   */

  var querySku =
    skuPrefix +
    isCD +
    '.0' +
    _depth +
    range;

  console.log(
    'Generated tag:',
    queryTag
  );

  console.log(
    'Generated SKU:',
    querySku
  );

  /*
   * Search tag first.
   */

  searchTagFirst(
    queryTag,
    querySku
  );
}


/* =========================================================
   STEP VISIBILITY
   ========================================================= */

function checkStepCompletion() {
  var lengthMain =
    document.getElementById(
      'length-main'
    );

  var widthMain =
    document.getElementById(
      'width-main'
    );

  var depthMain =
    document.getElementById(
      'depth-main'
    );

  if (
    !lengthMain ||
    !widthMain ||
    !depthMain
  ) {
    return;
  }

  var mervSelected =
    document.querySelector(
      'input[name="merv"]:checked'
    );

  /*
   * EXACT CLASSES FROM PROVIDED HTML.
   */

  var step3Section =
    document.querySelector(
      '.step-3-section'
    );

  var step4Section =
    document.querySelector(
      '.step-4-section'
    );

  var addToCartSection =
    document.querySelector(
      '.add-to-cart-section'
    );

  var step2Divider =
    document.querySelector(
      '.step-2-divider'
    );

  var step3Divider =
    document.querySelector(
      '.step-3-divider'
    );

  var step4Divider =
    document.querySelector(
      '.step-4-divider'
    );

  var dimensionsFilled =
    lengthMain.value !== '' &&
    widthMain.value !== '' &&
    depthMain.value !== '';

  var mervIsFilled =
    !!mervSelected;

  /*
   * =====================================================
   * STEP 1 + STEP 2 COMPLETE
   * =====================================================
   */

  if (
    dimensionsFilled &&
    mervIsFilled
  ) {
    /*
     * Step 2 divider:
     * between Step 2 and Step 3.
     */

    if (step2Divider) {
      step2Divider.style.display =
        'block';
    }

    /*
     * Step 3.
     */

    if (step3Section) {
      step3Section.style.display =
        'block';

      setTimeout(
        function () {
          step3Section.classList.add(
            'step-visible'
          );
        },
        10
      );
    }

    /*
     * Divider after Step 3.
     */

    if (step3Divider) {
      step3Divider.style.display =
        'block';
    }

    /*
     * Add-to-cart section becomes
     * available once dimensions/MERV
     * are complete.
     *
     * The ReCharge section itself
     * remains hidden until product
     * data has loaded.
     */

    if (addToCartSection) {
      addToCartSection.style.display =
        'flex';

      setTimeout(
        function () {
          addToCartSection.classList.add(
            'step-visible'
          );
        },
        10
      );
    }

    /*
     * Step 4 divider stays hidden
     * until ReCharge is actually loaded.
     */

    if (step4Divider) {
      step4Divider.style.display =
        'none';
    }

    return;
  }

  /*
   * =====================================================
   * STEP 1 / STEP 2 NOT COMPLETE
   * =====================================================
   */

  if (step2Divider) {
    step2Divider.style.display =
      'none';
  }

  if (step3Section) {
    step3Section.style.display =
      'none';

    step3Section.classList.remove(
      'step-visible'
    );
  }

  if (step3Divider) {
    step3Divider.style.display =
      'none';
  }

  if (step4Section) {
    step4Section.style.display =
      'none';

    step4Section.classList.remove(
      'step-visible'
    );
  }

  if (step4Divider) {
    step4Divider.style.display =
      'none';
  }

  if (addToCartSection) {
    addToCartSection.style.display =
      'none';

    addToCartSection.classList.remove(
      'step-visible'
    );
  }
}


/* =========================================================
   ADD TO CART
   ========================================================= */

function initializeAddToCart() {
  var addToCartBtn =
    document.querySelector(
      '.add-to-cart-btn'
    );

  if (!addToCartBtn) {
    console.warn(
      '.add-to-cart-btn not found'
    );

    return;
  }

  /*
   * Prevent duplicate listeners.
   */

  addToCartBtn.addEventListener(
    'click',
    handleAddToCart
  );
}


function handleAddToCart() {
  console.log(
    'Add to cart clicked'
  );

  var addToCartBtn =
    document.querySelector(
      '.add-to-cart-btn'
    );

  if (!addToCartBtn) {
    return;
  }

  var productHandle =
    addToCartBtn.dataset.productHandle;

  var variantId =
    addToCartBtn.dataset.variantId;

  var quantityElement =
    document.getElementById(
      'quantity-value'
    );

  var quantity =
    quantityElement
      ? parseInt(
          quantityElement.textContent,
          10
        ) || 1
      : 1;

  if (!productHandle || !variantId) {
    alert(
      'Please select filter dimensions and MERV rating first.'
    );

    return;
  }

  console.log(
    'Product handle:',
    productHandle
  );

  console.log(
    'Variant ID:',
    variantId
  );

  console.log(
    'Quantity:',
    quantity
  );

  /*
   * =====================================================
   * RECHARGE SUBSCRIPTION
   * =====================================================
   */

  var rcWidget =
    document.querySelector(
      '.rc-widget'
    );

  var rcSelectedOption = null;

  if (rcWidget) {
    rcSelectedOption =
      rcWidget.querySelector(
        '.rc-option--active input[type="radio"]'
      );

    /*
     * Some ReCharge versions use
     * a checked radio instead of the
     * active class.
     */

    if (!rcSelectedOption) {
      rcSelectedOption =
        rcWidget.querySelector(
          'input[type="radio"]:checked'
        );
    }
  }

  var isSubscription =
    !!(
      rcSelectedOption &&
      rcSelectedOption.value !==
        'onetime'
    );

  console.log(
    'ReCharge widget:',
    !!rcWidget
  );

  console.log(
    'Selected ReCharge option:',
    rcSelectedOption
  );

  console.log(
    'Subscription:',
    isSubscription
  );

  /*
   * =====================================================
   * CART DRAWER
   * =====================================================
   */

  var cartDrawer =
    document.querySelector(
      'cart-drawer'
    );

  /*
   * =====================================================
   * FORM DATA
   * =====================================================
   */

  var formData =
    new FormData();

  formData.append(
    'id',
    variantId
  );

  formData.append(
    'quantity',
    quantity
  );

  formData.append(
    'properties[Custom Size]',
    fullDimensions()
  );

  formData.append(
    'properties[_Pack_Size]',
    '6'
  );

  formData.append(
    'properties[_Shipping_Leadtime]',
    '5'
  );

  formData.append(
    'properties[Pack Size]',
    '6'
  );

  /*
   * ReCharge selling plan.
   */

  if (
    isSubscription &&
    rcSelectedOption
  ) {
    var sellingPlanName =
      rcSelectedOption.name ||
      '';

    console.log(
      'Selling plan name:',
      sellingPlanName
    );

    if (
      sellingPlanName.indexOf(
        'selling_plan_'
      ) === 0
    ) {
      var sellingPlanId =
        sellingPlanName.replace(
          'selling_plan_',
          ''
        );

      if (sellingPlanId) {
        formData.append(
          'selling_plan',
          sellingPlanId
        );

        console.log(
          'Selling plan added:',
          sellingPlanId
        );
      }
    }
  }

  /*
   * =====================================================
   * SHOPIFY CART SECTIONS
   * =====================================================
   */

  var sections =
    'cart-icon-bubble';

  if (cartDrawer) {
    var drawerSection =
      cartDrawer.closest(
        '.shopify-section'
      );

    if (
      drawerSection &&
      drawerSection.id
    ) {
      sections +=
        ',' +
        drawerSection.id.replace(
          'shopify-section-',
          ''
        );
    }
  }

  formData.append(
    'sections',
    sections
  );

  formData.append(
    'sections_url',
    window.location.pathname
  );

  console.log(
    'Cart form:',
    Object.fromEntries(
      formData
    )
  );

  /*
   * =====================================================
   * ADDING
   * =====================================================
   */

  addToCartBtn.textContent =
    'Adding...';

  addToCartBtn.disabled =
    true;

  /*
   * Get current cart before adding.
   */

  fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })

    .then(function (oldCartData) {
      return fetch(
        '/cart/add.js',
        {
          method: 'POST',

          headers: {
            Accept:
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest'
          },

          body: formData
        }
      )
        .then(function (response) {
          if (!response.ok) {
            return response
              .text()
              .then(
                function (text) {
                  throw new Error(
                    'Cart add failed: ' +
                    response.status +
                    ' - ' +
                    text
                  );
                }
              );
          }

          return response.json();
        })

        .then(function (data) {
          console.log(
            'Cart add success:',
            data
          );

          addToCartBtn.textContent =
            'Added to cart!';

          /*
           * Update cart icon.
           */

          updateCartIcon(data);

          /*
           * Update cart drawer.
           */

          setTimeout(
            function () {
              if (
                cartDrawer &&
                typeof cartDrawer.renderContents ===
                  'function'
              ) {
                cartDrawer.renderContents(
                  data,
                  true
                );
              }
            },
            700
          );

          /*
           * Get updated cart.
           */

          fetch('/cart.js')
            .then(
              function (response) {
                return response.json();
              }
            )

            .then(
              function (newCartData) {
                var oldItem =
                  oldCartData.items.find(
                    function (item) {
                      return (
                        String(
                          item.variant_id
                        ) ===
                        String(
                          data.variant_id
                        )
                      );
                    }
                  );

                if (oldItem) {
                  document.dispatchEvent(
                    new CustomEvent(
                      'on:line-item:change',
                      {
                        bubbles: true,

                        detail: {
                          cart:
                            newCartData,

                          variantId:
                            data.variant_id,

                          oldQuantity:
                            oldItem.quantity,

                          newQuantity:
                            data.quantity
                        }
                      }
                    )
                  );
                } else {
                  document.dispatchEvent(
                    new CustomEvent(
                      'on:cart:add',
                      {
                        bubbles: true,

                        detail: {
                          cart:
                            newCartData,

                          variantId:
                            data.variant_id
                        }
                      }
                    )
                  );
                }
              }
            );

          /*
           * Restore button.
           */

          setTimeout(
            function () {
              var basePrice =
                getActualProductPrice();

              var totalPrice =
                (
                  basePrice *
                  quantity
                ).toFixed(2);

              addToCartBtn.textContent =
                'Add to cart - $' +
                totalPrice;

              addToCartBtn.disabled =
                false;
            },
            2000
          );
        });
    })

    .catch(function (error) {
      console.error(
        'Add to cart error:',
        error
      );

      addToCartBtn.textContent =
        'Add to cart failed';

      document.dispatchEvent(
        new CustomEvent(
          'on:cart:error',
          {
            bubbles: true,

            detail: {
              error:
                error.message
            }
          }
        )
      );

      setTimeout(
        function () {
          var basePrice =
            getActualProductPrice();

          var totalPrice =
            (
              basePrice *
              quantity
            ).toFixed(2);

          addToCartBtn.textContent =
            'Add to cart - $' +
            totalPrice;

          addToCartBtn.disabled =
            false;
        },
        2000
      );
    });
}


/* =========================================================
   CART ICON
   ========================================================= */

function updateCartIcon(data) {
  var cartIconBubble =
    document.getElementById(
      'cart-icon-bubble'
    );

  if (
    cartIconBubble &&
    data &&
    data.sections &&
    data.sections[
      'cart-icon-bubble'
    ]
  ) {
    cartIconBubble.innerHTML =
      data.sections[
        'cart-icon-bubble'
      ];
  }
}


/* =========================================================
   LOCAL STORAGE
   ========================================================= */

function saveDimensionsToStorage() {
  var lengthMain =
    document.getElementById(
      'length-main'
    );

  var lengthFraction =
    document.getElementById(
      'length-fraction'
    );

  var widthMain =
    document.getElementById(
      'width-main'
    );

  var widthFraction =
    document.getElementById(
      'width-fraction'
    );

  var depthMain =
    document.getElementById(
      'depth-main'
    );

  if (
    !lengthMain ||
    !lengthFraction ||
    !widthMain ||
    !widthFraction ||
    !depthMain
  ) {
    return;
  }

  var dimensions = [
    lengthMain.value,
    lengthFraction.value,
    widthMain.value,
    widthFraction.value,
    depthMain.value
  ];

  try {
    localStorage.setItem(
      'dimensionsFilter',
      dimensions.join('|')
    );
  } catch (error) {
    console.warn(
      'Unable to save dimensions:',
      error
    );
  }
}


function loadSavedDimensions() {
  var savedDimensions = null;

  try {
    savedDimensions =
      localStorage.getItem(
        'dimensionsFilter'
      );
  } catch (error) {
    console.warn(
      'Unable to read saved dimensions:',
      error
    );
  }

  if (!savedDimensions) {
    return;
  }

  var values =
    savedDimensions.split('|');

  var dimensionInputs = [
    document.getElementById(
      'length-main'
    ),

    document.getElementById(
      'length-fraction'
    ),

    document.getElementById(
      'width-main'
    ),

    document.getElementById(
      'width-fraction'
    ),

    document.getElementById(
      'depth-main'
    )
  ];

  dimensionInputs.forEach(
    function (input, index) {
      if (
        input &&
        values[index] !==
          undefined
      ) {
        input.value =
          values[index];
      }
    }
  );
}